// extracted by mini-css-extract-plugin
module.exports = {"spotMapBottomLeft":"MapControls_spotMapBottomLeft__h0Z8Y","mapControlsLink":"MapControls_mapControlsLink__w4F3b","activeLink":"MapControls_activeLink__dUPGl"};